import { Inline } from '@etg/wings';
import { css, cx } from '@eti/styles';
import type { ComponentProps } from 'react';

const inlineStyles = css`
  & > :first-child {
    overflow: hidden;
    width: 33px;
  }

  & > :last-child {
    align-self: center;
    flex: 1;
    padding-block: 16px;
  }
`;

interface TimelineRowProps extends Omit<ComponentProps<typeof Inline>, 'spacing'> {}

const TimelineRow = ({ className, children, ...props }: TimelineRowProps) => (
  <Inline className={cx(inlineStyles, className)} spacing={16} {...props}>
    {children}
  </Inline>
);

export default TimelineRow;
